import GD from '../GD'
import { LocalStorage, LS } from '../utils'
import { detectOS } from '../utils/Helpers'

class Auth {
  private profile: IProfile | undefined
  private scheme: string | null = null
  private key = 'web'
  private devID: string | undefined | null
  private shared: IShared = window.DCC_SHARED
  private ls: LocalStorage = new LocalStorage()

  constructor() {
    GD.REQUEST_AUTHENTICATE.subscribe(async () => {
      if (this.shared.payerToken) {
        await this.authAsPayer()
      }
      else if (this.shared.traderToken) {
        await this.authAsTrader()
      }
      else if (this.shared.fxtoken) {
        await this.authAsFxComm()
      }
      else if (this.shared.viAuth) {
        this.authorized(JSON.parse(this.shared.viAuth))
      }
      else {
        await this.authAsGuest()
      }
    })

    GD.GET_PROFILE.listener = async () => {
      return this.profile
    }

    GD.LOGOUT.subscribe(() => {
      this.removeLocalUser()
    })

    GD.SERVICE_READY.invoke('auth')
  }

  private removeLocalUser() {
    localStorage.removeItem('chat_user_' + this.scheme)
    this.profile = undefined
    this.key = 'web'
  }

  public getDevID() {
    if (this.devID)
      return this.devID
    this.devID = this.ls.get(LS.DEVICE_ID)
    if (!this.devID) {
      this.devID = btoa((Math.random() * 10000 + (+new Date().getTime())) + navigator.userAgent).substr(0, 64)
      this.ls.set(LS.DEVICE_ID, this.devID)
    }
    return this.devID
  }

  private async authAsTrader() {
    const token = this.shared.traderToken as string
    let prefix = this.shared.branch === 'live' ? '2' : '3'

    const isJWT = token.match(/\./)

    if (isJWT) prefix = ''

    const resp = await GD.REQ_HTTP.request({
      method: 'auth.fxtrader',
      token: prefix + token,
      devID: this.getDevID(),
      deviceName: detectOS(),
      appVersion: 3,
      sts: true,
      deployedVersion: 'widget-mobile.js'
    })

    if (resp.error && resp.errorMsg) {
      GD.LOGE.invoke(resp.errorMsg)
      if (resp.errorMsg) {
        if (resp.errorMsg.indexOf('::') > -1) {
          resp.errorMsg = resp.errorMsg.split('::')[1]
          const mask = 'validateToken:'
          const index = resp.errorMsg.indexOf(mask)
          if (index > -1)
            resp.errorMsg = resp.errorMsg.substring(index + mask.length)
        }
        else
          resp.errorMsg = resp.errorMsg?.substring(8)
        GD.ALERT_ERROR.invoke(resp.errorMsg)
      }
      await this.authAsGuest()
      return
    }

    this.removeTokenFromMemory()

    this.authorized(resp.data)
  }

  private async authAsPayer() {
    const resp = await GD.REQ_HTTP.request({
      method: 'auth.payer',
      token: this.shared.payerToken
    })

    if (resp.error && resp.errorMsg) {
      GD.LOGE.invoke(resp.errorMsg)
      await this.authAsGuest()
      return
    }

    this.removeTokenFromMemory()

    this.authorized(resp.data)
  }

  private async authAsFxComm() {
    const resp = await GD.REQ_HTTP.request({
      method: 'auth.fxtoken',
      token: this.shared.fxtoken,
      devID: this.getDevID(),
      appVersion: 3,
      deviceName: detectOS(),
    })

    if (resp.error && resp.errorMsg) {
      GD.LOGE.invoke(resp.errorMsg)
      await this.authAsGuest()
      return
    }

    this.removeTokenFromMemory()

    this.authorized(resp.data)
  }

  private async authAsGuest() {
    const localAuth = this.ls.get<{ authKey: string, profile: IProfile }>(LS.AUTH)

    if (localAuth) {
      GD.LOG.invoke('Guest authorized from cache')
      this.authorized(localAuth)
      return
    }

    const resp = await GD.REQ_HTTP.request({
      method: 'auth.guest'
    })

    if (resp.error && resp.errorMsg) {
      GD.LOG.invoke(resp.errorMsg)
      return
    }

    this.ls.set(LS.AUTH, resp.data)
    this.authorized(resp.data)
  }

  private authorized(data: { authKey: string, profile: IProfile }) {
    this.key = data.authKey
    this.profile = data.profile

    const packet = { profile: this.profile, key: this.key }

    GD.LOG.invoke(packet)
    GD.AUTH_COMPLETE.invoke(packet)
  }

  private removeTokenFromMemory() {
    window.DCC_SHARED.token = undefined
    window.DCC_SHARED.payerToken = undefined
    window.DCC_SHARED.traderToken = undefined
    window.DCC_SHARED.fxtoken = undefined
    window.DCC_SHARED.viAuth = undefined
  }
}

export default Auth
